import { createAsyncThunk } from '@reduxjs/toolkit';
import CredentialQuizAPI from './credentialQuizAPI';

// -- User-facing --

export const fetchQuizTopicsThunk = createAsyncThunk(
  'credentialQuiz/fetchTopics',
  async (_, { rejectWithValue }) => {
    try {
      return await CredentialQuizAPI.fetchTopics();
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to fetch topics');
    }
  }
);

export const fetchQuizThunk = createAsyncThunk(
  'credentialQuiz/fetchQuiz',
  async ({ topicId, level }, { rejectWithValue }) => {
    try {
      const questions = await CredentialQuizAPI.fetchQuiz(topicId, level);
      return { topicId, level, questions };
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to fetch quiz questions');
    }
  }
);

export const submitQuizThunk = createAsyncThunk(
  'credentialQuiz/submitQuiz',
  async ({ topicId, level, answers }, { rejectWithValue }) => {
    try {
      return await CredentialQuizAPI.submitQuiz(topicId, level, answers);
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to submit quiz');
    }
  }
);

export const fetchMySummaryThunk = createAsyncThunk(
  'credentialQuiz/fetchMySummary',
  async (_, { rejectWithValue }) => {
    try {
      return await CredentialQuizAPI.fetchMySummary();
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to fetch knowledge summary');
    }
  }
);

// -- Admin --

export const adminFetchTopicsThunk = createAsyncThunk(
  'credentialQuiz/adminFetchTopics',
  async (_, { rejectWithValue }) => {
    try {
      return await CredentialQuizAPI.adminFetchTopics();
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to fetch topics');
    }
  }
);

export const adminCreateTopicThunk = createAsyncThunk(
  'credentialQuiz/adminCreateTopic',
  async (payload, { rejectWithValue }) => {
    try {
      return await CredentialQuizAPI.adminCreateTopic(payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to create topic');
    }
  }
);

export const adminUpdateTopicThunk = createAsyncThunk(
  'credentialQuiz/adminUpdateTopic',
  async ({ topicId, payload }, { rejectWithValue }) => {
    try {
      return await CredentialQuizAPI.adminUpdateTopic(topicId, payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to update topic');
    }
  }
);

export const adminDeleteTopicThunk = createAsyncThunk(
  'credentialQuiz/adminDeleteTopic',
  async (topicId, { rejectWithValue }) => {
    try {
      return await CredentialQuizAPI.adminDeleteTopic(topicId);
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to delete topic');
    }
  }
);

export const adminFetchQuestionsThunk = createAsyncThunk(
  'credentialQuiz/adminFetchQuestions',
  async (topicId, { rejectWithValue }) => {
    try {
      const questions = await CredentialQuizAPI.adminFetchQuestions(topicId);
      return { topicId, questions };
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to fetch questions');
    }
  }
);

export const adminCreateQuestionThunk = createAsyncThunk(
  'credentialQuiz/adminCreateQuestion',
  async ({ topicId, payload }, { rejectWithValue }) => {
    try {
      const question = await CredentialQuizAPI.adminCreateQuestion(topicId, payload);
      return { topicId, question };
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to create question');
    }
  }
);

export const adminUpdateQuestionThunk = createAsyncThunk(
  'credentialQuiz/adminUpdateQuestion',
  async ({ questionId, payload }, { rejectWithValue }) => {
    try {
      return await CredentialQuizAPI.adminUpdateQuestion(questionId, payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to update question');
    }
  }
);

export const adminDeleteQuestionThunk = createAsyncThunk(
  'credentialQuiz/adminDeleteQuestion',
  async ({ questionId, topicId }, { rejectWithValue }) => {
    try {
      await CredentialQuizAPI.adminDeleteQuestion(questionId);
      return { questionId, topicId };
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || err.message || 'Failed to delete question');
    }
  }
);
